export default __webpack_public_path__ + "074014c55842fc35c2d317b58b0704ec.jpg";